import { render, staticRenderFns } from "./BowContentListMediaDx.vue?vue&type=template&id=b7525d8a&"
import script from "./BowContentListMediaDx.vue?vue&type=script&lang=js&"
export * from "./BowContentListMediaDx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowContentListMedia: require('/workspace/components/organisms/BowContentListMedia/BowContentListMedia.vue').default})
